import React from "react";
import SmallLoader from "../Common/smallLoader";
import { checkString, getName } from "../../CommonMethhods/CommonMethods";



function ComplianceApplicationStatus(props) {
  let frenchiseeDatails = props.frenchiseeDatails;
  const loader = props.loader;
  function addressArray(array) {
    let a = "";
    array.forEach((item) => {
      if (item.length > 0) {
        if (item != " " && item != "NA") a = a + item + ",";
      }
    });
    return a.length > 0 ? a : "NA";
  }

  const Address1 =
    frenchiseeDatails === undefined || null
      ? "NA"
      : checkString(frenchiseeDatails?.officeAddressTypeAddress1);

  const Address2 =
    frenchiseeDatails === undefined || null
      ? "NA"
      : checkString(frenchiseeDatails?.officeAddressTypeAddress2);

  const State =
    frenchiseeDatails === undefined || null
      ? "NA"
      : checkString(frenchiseeDatails?.officeAddressTypeState);

  const City =
    frenchiseeDatails === undefined || null
      ? "NA"
      : checkString(frenchiseeDatails?.officeAddressTypeCity);

  const Zip =
    frenchiseeDatails === undefined || null
      ? "NA"
      : checkString(frenchiseeDatails?.officeAddressTypePinCode);

  const GetFName =
    frenchiseeDatails === undefined || null
      ? " "
      : frenchiseeDatails?.name === undefined || null
        ? " "
        : frenchiseeDatails?.name;



  return (
    <>
      <div className="user-profile card-box  partner-application">
        <div>
          <div className="user-profile__top">
            <div className="profile__details d-flex">
              <div className="profile__img">
                {frenchiseeDatails === undefined || null ? (
                  <h2 className="profile-img-name">NA</h2>
                ) : frenchiseeDatails.profilePic === undefined || null || " " ? (
                  <h2 className="profile-img-name">{getName(GetFName)}</h2>

                ) : (
                  <img
                    className="profile-pic"
                    src={frenchiseeDatails.profilePic}
                    alt="User Profile Icon"
                  />
                )}

              </div>
              <div className="profile__details__wrapper">
                <div className="user__details">
                  <div>
                    {loader ? (
                      <SmallLoader />
                    ) : (
                      <h3 className="user__details__name">
                        {GetFName}
                      </h3>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="user-profile__bottom row">
            <div className="col-12 col-md-6 contact">
              <p className="contact-number contact__details">
                <span className="icon-phone-icon"> </span>
                
                {loader ? (
                  <SmallLoader />
                ) :
                  frenchiseeDatails === undefined || null ? (
                    "NA"
                  ) : (
                    checkString(frenchiseeDatails?.mobile)
                  )}
              </p>

              <p className="email contact__details">
                <span className="icon-email">

                </span>
                {loader ? (
                  <SmallLoader />
                ) :
                  frenchiseeDatails === undefined || null ? (
                    "NA"
                  ) : (
                    checkString(frenchiseeDatails?.email)
                  )}

              </p>
              <p className="location contact__details">
                <span className="icon-location"></span>

                {/* {Address1 + "," + Address2 + "," + State + "," + City + "," + Zip} */}
                {loader ? (
                  <SmallLoader />
                ) : (
                  // </div>
                  addressArray([Address1, Address2, State, City, Zip])
                )}

              </p>

              <p className="code contact__details">
                <span className="icon-id-card"></span>
                {loader ? (
                  <SmallLoader />
                ) :
                  frenchiseeDatails === undefined || null ? (
                    "NA"
                  ) : (
                    checkString(frenchiseeDatails?.pan)
                  )}
              </p>
            </div>
            <div className="col-12 col-md-6 contact-right">
              <div className="contact-right__top d-flex align-items-end">
                <div className="referred-by">
                  <p className="bank-title">
                    Bank Details
                  </p>
                </div>
              </div>
              <ul className="contact-right__bottom">
                <li className="referrence-details">
                  <p className="bank-label">Bank Name</p>
                  <p className="bank-value">
                    {loader ? (
                      <SmallLoader />
                    ) :
                      frenchiseeDatails === undefined || null ? (
                        "NA"
                      ) : (
                        checkString(frenchiseeDatails?.bankName)
                      )}
                  </p>
                </li>
                <li className="referrence-details">
                  <p className="bank-label">
                    Account Number
                  </p>
                  <p className="bank-value">
                    {loader ? (
                      <SmallLoader />
                    ) :
                      frenchiseeDatails === undefined || null || "" ? (
                        "NA"
                      ) : (
                        checkString(frenchiseeDatails?.accNo)
                      )}
                  </p>
                </li>

                <li className="referrence-details">
                  <p className="bank-label">
                    IFSC Code
                  </p>
                  <p className="bank-value">
                    {loader ? (

                      <SmallLoader />
                    ) :
                      frenchiseeDatails === undefined || null ? (
                        "NA"
                      ) : (
                        checkString(frenchiseeDatails?.ifsc)
                      )}
                  </p>
                </li>

              </ul>
            </div>
          </div>
        </div>
        {/* )} */}
      </div>
    </>
  );
}

export default ComplianceApplicationStatus;
